import { FilledCheckIcon, FilledWarningIcon } from '@cfs-fixings/shared'
import classNames from 'classnames'

const utilisationThreshold = 100

type UtilisationPercentagePillProps = {
  percentage: number;
}

const UtilisationPercentagePill = ({ percentage }: UtilisationPercentagePillProps) => {
  return (
    <div className={classNames('flex flex-row items-center gap-1 rounded-full border text-sm px-2 py-[3px]', {
      'bg-error-300 border-error-400': percentage > utilisationThreshold,
      'bg-green-300 border-green-400': percentage <= utilisationThreshold,
    })}
    >
      {
        percentage > utilisationThreshold
          ? <FilledWarningIcon className="text-error-500" />
          : <FilledCheckIcon className="text-green-600" />
      }
      {percentage.toFixed(0)}%
    </div>
  )
}

export default UtilisationPercentagePill
